import {Box, IInputProps, Input as NativeInput} from 'native-base';
import React from 'react';
import {t} from 'react-native-tailwindcss';

export type InputProps = IInputProps & {};

export const Input = React.forwardRef<any, InputProps>(
  ({style, returnKeyType, blurOnSubmit, ...rest}, ref) => {
    return (
      <Box style={styles.wrapper}>
        <NativeInput ref={ref!} style={[styles.input, style]} {...rest} />
      </Box>
    );
  }
);

const styles = {
  wrapper: [t.selfStretch],
  input: [t.h11, t.selfStretch, t.p3, t.textBase, t.textGray700]
};
